import { useTranslation } from 'react-i18next';
import { HiArrowUpRight } from 'react-icons/hi2';
import { utilService } from '../services/util.service';
import { ISearchProps } from './app-header/app-header';

export function SearchTeaser({
  onChangeModule,
  searchBy,
  isExpandedClass,
  onChangeIsExpanded,
  handleFormSubmit,
}: ISearchProps) {
  const { t } = useTranslation();

  const locationLabel =
    searchBy.city && searchBy.state
      ? `${searchBy.city}, ${searchBy.state}`
      : searchBy.state || searchBy.city || t('search-teaser-location-anywhere');

  const dateLabel =
    searchBy.startDate && searchBy.endDate
      ? utilService.formatDateMMMd(searchBy)
      : t('search-teaser-date-any-week');

  const openModule = (module: string) => {
    onChangeIsExpanded(true);
    onChangeModule(module);
  };

  return (
    <section className={`search-teaser ${isExpandedClass}`}>
      <button
        type="button"
        className="search-teaser__segment"
        onClick={() => openModule('location')}
      >
        <span className="search-teaser__label">{t('search-form-label-where')}</span>
        <span className="search-teaser__value">{locationLabel}</span>
      </button>
      <button
        type="button"
        className="search-teaser__segment"
        onClick={() => openModule('startDate')}
      >
        <span className="search-teaser__label">{t('search-form-label-when')}</span>
        <span className="search-teaser__value">{dateLabel}</span>
      </button>
      <button
        className="search-teaser__submit"
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          if (isExpandedClass) {
            handleFormSubmit();
          } else {
            onChangeIsExpanded(true);
            onChangeModule('location');
          }
        }}
        aria-label={t('search-module-button-search')}
      >
        <span className="search-teaser__submit-text">{t('search-module-button-search')}</span>
        <HiArrowUpRight size={18} />
      </button>
    </section>
  );
}
